import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'

import { APPOINTMENT_APPROVED_STATES } from 'components/HFInputs/HFAppointmentProtocol'

import styles from '../widgets.module.sass'

const AppointmentsProtocols = (props) => {
	const { data } = props
	const {
		appointmentProcessProtocols,
		medicalSpecialties,
		providerEntities,
		appointments,
	} = data
	const { i18n } = useGlobal()

	return appointmentProcessProtocols?.length ? (
		<>
			<HStack
				className={styles['protocol-line']}
				columns={[3, 3, 1]}
				gap='xsmall'
				justify='space-between'
			>
				<small>
					<strong>{i18n`Expertise`}</strong>
				</small>
				<small>
					<strong>{i18n`Provider`}</strong>
				</small>
				<small>
					<strong>{i18n`Qtd.`}</strong>
				</small>
			</HStack>
			{(appointmentProcessProtocols || []).map(
				({ serviceProviderId, specialtyId, quantity }, key) => {
					const totalAppointmentsForSpecialty =
						appointments?.filter(
							(a) =>
								APPOINTMENT_APPROVED_STATES.includes(
									a.status?.id
								) &&
								parseInt(a.medicalSpecialty?.id, 10) ===
									parseInt(specialtyId, 10)
						).length ?? 0

					return (
						<HStack
							key={key}
							className={styles['protocol-line']}
							columns={[3, 3, 1]}
							gap='xsmall'
							justify='space-between'
						>
							<Tooltip
								text={medicalSpecialties[specialtyId] || ''}
								delay={0}
							>
								<small>
									{medicalSpecialties[specialtyId] || ''}
								</small>
							</Tooltip>
							<small>
								{providerEntities[serviceProviderId] ??
									i18n`None`}
							</small>
							<small>
								{totalAppointmentsForSpecialty}/{quantity}
							</small>
						</HStack>
					)
				}
			)}
		</>
	) : (
		<Widget className={styles['centered']} justify='center'>
			<small>
				<strong>{i18n`There are no appointment protocols for the process.`}</strong>
			</small>
		</Widget>
	)
}

export default AppointmentsProtocols
